import { Component, OnDestroy, OnInit } from '@angular/core';
import { NEW_SYSTEM_CUTOFF, NEW_SYSTEM_URL } from '../../classes/migration-notice';

@Component({
  selector: 'app-migration-banner',
  templateUrl: './migration-banner.component.html',
  styleUrls: ['./migration-banner.component.scss']
})
export class MigrationBannerComponent implements OnInit, OnDestroy {
  newSystemUrl = NEW_SYSTEM_URL;
  cutoff = NEW_SYSTEM_CUTOFF;
  expired = false;
  days = 0;
  hours = '00';
  minutes = '00';
  seconds = '00';
  private timer: any;

  ngOnInit(): void {
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }

  private tick() {
    const diff = this.cutoff.getTime() - Date.now();
    if (diff <= 0) {
      this.expired = true;
      this.days = 0;
      this.hours = this.minutes = this.seconds = '00';
      return;
    }
    const totalSeconds = Math.floor(diff / 1000);
    this.days = Math.floor(totalSeconds / 86400);
    this.hours = this.pad(Math.floor((totalSeconds % 86400) / 3600));
    this.minutes = this.pad(Math.floor((totalSeconds % 3600) / 60));
    this.seconds = this.pad(totalSeconds % 60);
  }

  private pad(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }
}
